"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.object.keys.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.object.assign.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name.js");

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Checkbox = _interopRequireDefault(require("material-ui/Checkbox"));

var _TextField = _interopRequireDefault(require("material-ui/TextField"));

var _DatePicker = _interopRequireDefault(require("material-ui/DatePicker"));

var _TimePicker = _interopRequireDefault(require("material-ui/TimePicker"));

var _SelectField = _interopRequireDefault(require("material-ui/SelectField"));

var _AutoComplete = _interopRequireDefault(require("material-ui/AutoComplete"));

var _eventNormalization = require("@evdy/web-etc/dist/lib/eventNormalization");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var RepeaterField = /*#__PURE__*/function (_React$Component) {
  _inherits(RepeaterField, _React$Component);

  var _super = _createSuper(RepeaterField);

  function RepeaterField() {
    _classCallCheck(this, RepeaterField);

    return _super.apply(this, arguments);
  }

  _createClass(RepeaterField, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$context = this.context,
          fns = _this$context.fns,
          idx = _this$context.idx;

      var _this$props = this.props,
          name = _this$props.name,
          label = _this$props.label,
          type = _this$props.type,
          className = _this$props.className,
          component = _this$props.component,
          clear = _this$props.clear,
          hidden = _this$props.hidden,
          noArrow = _this$props.noArrow,
          blankValid = _this$props.blankValid,
          rest = _objectWithoutProperties(_this$props, ["name", "label", "type", "className", "component", "clear", "hidden", "noArrow", "blankValid"]);

      var _component = typeof component === 'undefined' ? _TextField.default : component;

      rest.value = fns.getValue(name, idx);
      rest.floatingLabelText = label;

      if (rest.errorText) {
        rest.errorText = rest.errorText(idx);
      } else {
        rest.errorText = fns.getErrorText(name, idx);
      }

      if (rest.onBlur) {
        rest.onBlur = rest.onBlur(idx);
      }

      switch (_component) {
        case _DatePicker.default:
          rest.onChange = (0, _eventNormalization.normalizeDateEvent)(name, fns.handleChange(name, idx));
          break;

        case _SelectField.default:
          rest.onChange = (0, _eventNormalization.normalizeSelectEvent)(name, fns.handleChange(name, idx));
          break;

        case _TimePicker.default:
          rest.onChange = (0, _eventNormalization.normalizeTimeEvent)(name, fns.handleChange(name, idx));
          break;

        case _AutoComplete.default:
          rest.value = undefined;
          rest.searchText = fns.getValue(name, idx);
          rest.onNewRequest = rest.onNewRequest(idx);
          rest.onUpdateInput = rest.onUpdateInput(idx);
          break;

        case _Checkbox.default:
          rest.label = label;
          rest.onCheck = rest.onCheck(idx);
          delete rest.errorText;
          delete rest.floatingLabelText;
          break;

        default:
          if (type === 'tel') {
            rest.onChange = fns.handlePhoneChange(name, idx);
          } else {
            rest.onChange = fns.handleChange(name, idx);
          }

      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: !hidden && !noArrow && "".concat(fns.getClass(name, idx), " ").concat(blankValid && 'blank-valid')
      }, /*#__PURE__*/_react.default.createElement(_component, _extends({
        ref: function ref(el) {
          return _this._baseComponent = el;
        },
        name: fns.makeKey(name, idx),
        type: type,
        className: className
      }, rest)), clear && fns.getValue(name, idx) && /*#__PURE__*/_react.default.createElement("div", {
        className: "date-time-clear",
        onClick: function onClick() {
          return fns.clearField(name, idx);
        }
      }));
    }
  }]);

  return RepeaterField;
}(_react.default.Component);

exports.default = RepeaterField;
RepeaterField.contextTypes = {
  idx: _propTypes.default.number,
  fns: _propTypes.default.objectOf(_propTypes.default.func)
};
RepeaterField.propTypes = {
  id: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  label: _propTypes.default.string,
  fns: _propTypes.default.shape({
    makeKey: _propTypes.default.func.isRequired,
    getValue: _propTypes.default.func.isRequired,
    handleChange: _propTypes.default.func.isRequired,
    getErrorText: _propTypes.default.func.isRequired,
    clearField: _propTypes.default.func
  }),
  type: _propTypes.default.string,
  className: _propTypes.default.string,
  errorText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  clear: _propTypes.default.bool,
  hidden: _propTypes.default.bool,
  noArrow: _propTypes.default.bool
};
RepeaterField.defaultProps = {
  type: 'text',
  className: 'form-input'
};